import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-1">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={onClose} data-id="element-2" />
          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-navy-light border border-navy-lighter rounded-xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-3">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-navy-lighter flex-shrink-0" data-id="element-4">
              <h2 className="font-serif text-xl font-bold text-cream" data-id="element-5">
                {title}
              </h2>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full text-cream-muted hover:text-cream hover:bg-navy-lighter transition-colors" aria-label="Cerrar" data-id="element-6">
                <X className="w-5 h-5" data-id="element-7" />
              </button>
            </div>
            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto text-cream-muted text-base leading-relaxed space-y-4" data-id="element-8">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full py-8 px-6 bg-navy border-t border-navy-lighter text-center" data-id="element-9">
        <div className="max-w-4xl mx-auto" data-id="element-10">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-11">
            <button onClick={() => setShowPrivacy(true)} className="text-cream-muted/60 text-sm hover:text-gold transition-colors underline underline-offset-2" data-id="element-12">
              Política de Privacidad
            </button>
            <span className="text-cream-muted/30" data-id="element-13">|</span>
            <button onClick={() => setShowTerms(true)} className="text-cream-muted/60 text-sm hover:text-gold transition-colors underline underline-offset-2" data-id="element-14">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-cream-muted/60 text-sm" data-id="element-15">
            © {new Date().getFullYear()} El Protocolo 3AM. Todos los derechos
            reservados.
          </p>
          <p className="text-cream-muted/40 text-xs mt-2" data-id="element-16">
            Solo para fines informativos y educativos.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-17">
        <p className="text-cream font-semibold" data-id="element-18">
          Última actualización: {new Date().getFullYear()}
        </p>
        <p data-id="element-19">
          Tu privacidad es importante para nosotros. Esta política describe qué
          información recopilamos, cómo la usamos y cómo la protegemos.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-20">
          1. Información que recopilamos
        </h3>
        <p data-id="element-21">
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar tu pedido: nombre, dirección de correo electrónico y
          datos de pago. Los datos de pago son procesados de forma segura por
          nuestro proveedor de pagos y no se almacenan en nuestros servidores.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-22">
          2. Uso de la información
        </h3>
        <p data-id="element-23">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-24">
          <li data-id="element-25">Entregar el producto digital que adquiriste.</li>
          <li data-id="element-26">Enviarte el correo de confirmación de compra.</li>
          <li data-id="element-27">Comunicarnos contigo si hay algún problema con tu pedido.</li>
        </ul>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-28">
          3. Compartir información
        </h3>
        <p data-id="element-29">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          la ley lo requiera.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-30">4. Seguridad</h3>
        <p data-id="element-31">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal contra acceso no autorizado, alteración o
          destrucción.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-32">5. Tus derechos</h3>
        <p data-id="element-33">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento. También puedes solicitar acceso a la información que tenemos
          sobre ti.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-34">
          6. Cambios a esta política
        </h3>
        <p data-id="element-35">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios serán publicados en esta página.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-36">
        <p className="text-cream font-semibold" data-id="element-37">
          Última actualización: {new Date().getFullYear()}
        </p>
        <p data-id="element-38">
          Al comprar y utilizar «El Protocolo 3AM», aceptas los siguientes
          términos y condiciones.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-39">
          1. Producto digital
        </h3>
        <p data-id="element-40">
          «El Protocolo 3AM» es un producto digital en formato PDF. Una vez
          completada la compra, recibirás acceso inmediato al archivo
          descargable. Debido a la naturaleza digital del producto, todas las
          ventas son finales.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-41">2. Uso personal</h3>
        <p data-id="element-42">
          El contenido es para tu uso personal únicamente. No está permitido
          redistribuir, revender, copiar o compartir el material sin
          autorización expresa.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-43">
          3. Disclaimer médico
        </h3>
        <p data-id="element-44">
          Este material es solo para fines informativos y educativos. No
          constituye consejo médico y no sustituye la atención de un profesional
          de la salud. Si tus síntomas son frecuentes, intensos o preocupantes,
          o sospechas apnea del sueño u otra condición médica, busca evaluación
          médica. No cambies medicamentos sin consultar a tu médico. Los
          resultados varían de persona a persona y este protocolo no garantiza
          resultados específicos.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-45">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-46">
          Todo el contenido de «El Protocolo 3AM», incluyendo textos, diseños,
          gráficos y estructura, está protegido por derechos de autor. Queda
          prohibida su reproducción total o parcial sin autorización.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-47">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-48">
          No nos hacemos responsables por el uso que le des al contenido de esta
          guía. El usuario asume toda la responsabilidad por las decisiones que
          tome basándose en este material.
        </p>
        <h3 className="text-cream font-bold text-lg mt-2" data-id="element-49">6. Modificaciones</h3>
        <p data-id="element-50">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. El uso continuado del producto después de cualquier cambio
          constituye la aceptación de los nuevos términos.
        </p>
      </LegalModal>
    </>;
}